export default function AuditBreakdown() {
  const sections = [
    {
      number: '01',
      title: '底層出廠設定解析',
      items: [
        { label: '硬編碼物理特徵映射', description: '透過時空參數深度解析您的基線元素配置。識別您的預設行為模式、決策速度與認知操作系統。' },
        { label: '基線元素校準', description: '嚴格映射您的核心元素結構（金、木、水、火、土），驗證系統與您已記錄行為現實的對齊程度。' },
      ],
    },
    {
      number: '02',
      title: '情緒—職業合成矩陣',
      items: [
        { label: '交叉引用行為模式', description: '分析您當前的關係狀態、職業角色與人生階段如何交叉，形成認知盲點與隱藏風險容忍度。' },
        { label: '認知盲點識別', description: '精確識別您的情緒狀態與職業執行需求交匯的臨界點——以及過度延伸風險的峰值所在。' },
      ],
    },
    {
      number: '03',
      title: '歷史周期驗證',
      items: [
        { label: '宏觀摩擦分析', description: '對環境時機動態進行實時模擬。每個周期都針對您的基線配置進行壓力測試，以識別摩擦點與最佳執行窗口。' },
        { label: '環境時機校準', description: '可視化宏觀環境周期將在何處製造阻力——以及基線防禦必須在何處加強。' },
      ],
    },
    {
      number: '04',
      title: '2026 環境變量碰撞',
      items: [
        { label: '時空概率收斂計算', description: '將您的底層出廠設定與 2026 年宏觀環境變量進行多維度碰撞，計算時空概率的絕對收斂點。' },
        { label: '多維度共振分析', description: '東方干支系統與西方靈數學的集成學習投票，消除單一模型的系統性偏差，輸出最高置信度預測。' },
      ],
    },
    {
      number: '05',
      title: '流動性防禦協議',
      items: [
        { label: '風險對沖策略', description: '針對您的認知盲點與高摩擦期，制定具體的流動性防禦策略，構建對抗未知變數的絕對導航座標。' },
        { label: '多維度防禦架構', description: '跨越情緒、職業、財務三個維度的整合防禦框架，確保在環境變量劇烈波動時的系統穩定性。' },
      ],
    },
    {
      number: '06',
      title: '12 個月高頻預警圖',
      items: [
        { label: '月度戰術行動協議', description: '精確定位前 3 個最高摩擦月份，並為每個月份提供具體的戰術建議與執行窗口推薦。' },
        { label: '戰略指令', description: '一條清晰、明確的戰略指令，將您的運營姿態與計算出的宏觀環境對齊——演算引擎的最終輸出。' },
      ],
    },
  ];

  return (
    <div id="audit-details" className="bg-[#0a0a0f] border border-[#00ffb4]/10 text-white p-12 md:p-20 rounded-lg mt-10">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block border border-[#00ffb4]/30 bg-[#00ffb4]/5 px-5 py-1.5 rounded-full text-xs tracking-[0.25em] mb-8 font-mono text-[#00ffb4]">
            FULL REPORT OVERVIEW
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            TWINODE 核心報告：<br />內含什麼？
          </h2>
          <p className="text-sm text-gray-500 max-w-xl mx-auto leading-relaxed">
            您個人化 TWINODE 報告中每個模組的結構化分解——6 大矩陣深度整合分析，零模糊地帶。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-16">
          {sections.map((section) => (
            <div key={section.number} className="group">
              <div className="flex items-baseline gap-4 mb-6">
                <span className="text-4xl font-bold text-white/5 group-hover:text-[#00ffb4]/20 transition-colors duration-300">
                  {section.number}
                </span>
                <h3 className="text-base font-bold leading-snug text-white">{section.title}</h3>
              </div>
              <div className="w-full h-px bg-[#00ffb4]/10 mb-6" />
              <div className="space-y-5">
                {section.items.map((item) => (
                  <div key={item.label} className="pl-1">
                    <h4 className="text-sm font-semibold text-white/80 mb-1.5 tracking-wide">{item.label}</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
